import React from "react";
import { RING_ORDER, RING_RADII, ringDash, ringLabel } from "../../../core/data/auditsPage";
import { INDUSTRY } from "../../../core/theme/auditsTheme";

// Three rings, outer to inner: searches, locations, keywords. Each fills to
// its share of the target and closes when the target is met. No targets
// (progress null) = three empty rings.
export default function TargetRings({ progress }) {
  return (
    <svg viewBox="0 0 150 150" role="img" aria-label={ringLabel(progress)} className={INDUSTRY.rings}>
      <g transform="rotate(-90 75 75)">
        {RING_ORDER.map((t, i) => (
          <React.Fragment key={t}>
            <circle cx="75" cy="75" r={RING_RADII[i]} strokeWidth="12" className={INDUSTRY.ringTrack} />
            {progress && progress[t].percent > 0 && (
              <circle
                cx="75" cy="75" r={RING_RADII[i]} strokeWidth="12" strokeLinecap="round"
                strokeDasharray={ringDash(progress[t].percent, RING_RADII[i])} className={INDUSTRY.ringFill[i]}
              />
            )}
          </React.Fragment>
        ))}
      </g>
    </svg>
  );
}
